import { addModalOpenClass, removeModalOpenClass } from '@/utils/helper';
import React, { useEffect } from 'react';

interface ImageModalProps {
  isOpen: boolean;
  imageUrl: string;
  imageName: string;
  isDownloadable?: boolean;
  width?: number;
  height?: number;
  onClose: () => void;
}
export type ImageModalType = {
  open: boolean;
  imageUrl: string;
  imageName: string;
  isDownloadable?: boolean;
  width?: number;
  height?: number;
  onClose: () => void;
};
const ImageModal: React.FC<ImageModalProps> = ({
  isOpen,
  imageUrl,
  imageName,
  isDownloadable,
  width,
  height,
  onClose,
}) => {
  useEffect(() => {
    if (isOpen) {
      addModalOpenClass();
    }
    return () => {
      removeModalOpenClass();
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const downloadImage = () => {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = imageName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="delete-modal-overlay" onClick={onClose}>
      <div
        className="delete-confirmation-modal image-modal-qr"
        onClick={(e) => e.stopPropagation()}
      >
        {/* <button className="dismiss-modal" onClick={onClose}>&times;</button> */}
        <div className="delete-modal-icon">
          <img
            src={imageUrl}
            alt={imageName}
            style={{
              width: width ? `${width}px` : 'auto',
              height: height ? `${height}px` : 'auto',
            }}
          />
        </div>

        {isDownloadable && (
          <div className="form-actions buttons-group justify-center">
            <button className="btn btn--sm btn--pri" onClick={downloadImage}>
              Download
            </button>
            <button className="btn btn--sm btn--sec" onClick={onClose}>
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageModal;
